import React from 'react'

import HospitalHomeDirectorDoctorRegister from 'presentation/hospital/pages/Home/DirectorDoctorRegister'

export default function makeHospitalDirectorDoctorRegisterHome() {
  return <HospitalHomeDirectorDoctorRegister />
}
